<script>
    import { navigate } from 'svelte-routing';
    import { encode, decode } from 'js-base64';
    import { fetchOffer } from '../clients/OfferClient.svelte';
    import { store, store_offer } from '../Store.svelte';
    import { getProductFromProductId } from '../Util.svelte';
    import { env } from '../Environment.svelte';
    import Preloader from '../components/Preloader.svelte';

    {
        // Clean store
        $store.requestedServices = env.cleanstore.requestedServices;
        $store.purchaseStatus = env.cleanstore.purchaseStatus;
    }

    const token = window.location.pathname.replace(
        '/receiver/purchase-sky/',
        ''
    );

    let receivedProduct = {};
    let isSky = false;
    if (token != null) {
        try {
            const receivedUserData = JSON.parse(decode(token));
            $store.requestedAddress.addressId =
                receivedUserData.addressId != null
                    ? receivedUserData.addressId
                    : '';
            $store.requestedAddress.postalCode =
                receivedUserData.postalCode != null
                    ? receivedUserData.postalCode
                    : '';
            $store.requestedAddress.addressString =
                receivedUserData.addressString != null
                    ? receivedUserData.addressString
                    : '';
            $store.requestedAddress.offnetCoverage =
                receivedUserData.offnetCoverage != null
                    ? receivedUserData.offnetCoverage
                    : false;

            $store.requestedAddress.addressRPT =
                receivedUserData.addressRPT != null &&
                receivedUserData.addressRPT != undefined
                    ? receivedUserData.addressRPT
                    : '';
            $store.requestedAddress.street =
                receivedUserData.calle != null &&
                receivedUserData.calle != undefined
                    ? receivedUserData.calle
                    : '';
            $store.requestedAddress.suburb =
                receivedUserData.colonia != null &&
                receivedUserData.colonia != undefined
                    ? receivedUserData.colonia
                    : '';
            $store.requestedAddress.city =
                receivedUserData.delegacion != null &&
                receivedUserData.delegacion != undefined
                    ? receivedUserData.delegacion
                    : '';
            $store.requestedAddress.state =
                receivedUserData.estado != null &&
                receivedUserData.estado != undefined
                    ? receivedUserData.estado
                    : '';
            $store.requestedAddress.externalNumber =
                receivedUserData.numero != null &&
                receivedUserData.numero != undefined
                    ? receivedUserData.numero
                    : '';
            $store.requestedAddress.internalNumber =
                receivedUserData.interior != null &&
                receivedUserData.interior != undefined
                    ? receivedUserData.interior
                    : '';
            $store.requestedAddress.latitude =
                receivedUserData.latitud != null &&
                receivedUserData.latitud != undefined
                    ? receivedUserData.latitud
                    : '';
            $store.requestedAddress.longitude =
                receivedUserData.longitud != null &&
                receivedUserData.longitud != undefined
                    ? receivedUserData.longitud
                    : '';

            isSky = receivedUserData.isSky;
            receivedProduct = receivedUserData;
        } catch (e) {
            console.log(e);
        }
    }
    $store.requestedServices = env.cleanstore.requestedServices;
    $store.purchaseStatus = env.cleanstore.purchaseStatus;
    $store.personalDetails = env.cleanstore.personalDetails;
    $store.settings.location = {};
    $store.requestedServices.isSky = isSky;

    let fetchOfferWithAddress = () =>
        fetchOffer(
            $store.requestedAddress.postalCode,
            $store.requestedAddress.addressId,
            $store.requestedAddress.offnetCoverage
        ).then((response) => {
            if (response != null) {
                //$store_offer.loadedOffer = response;
                //$store_offer.dateLoaded = new Date();
                store_offer.set(env.cleanstore_offer);
                store_offer.set({
                    dateLoaded: new Date(),
                    loadedOffer: response,
                });
                activateOffers();
                var product = getProductFromProductId(
                    response.offers,
                    receivedProduct
                );
                $store.requestedServices.productObject =
                    env.cleanstore.requestedServices.productObject;
                if (product != null) {
                    $store.requestedServices.product = product;
                    $store.requestedServices.productId = product.paqId;
                    navigate('/compra/configura', { replace: false });
                } else {
                    if (
                        receivedProduct.productFamily != null &&
                        receivedProduct.productFamily.indexOf('izzinegocios') >
                            -1
                    ) {
                        navigate('/comparador/negocios', { replace: false });
                    } else if (receivedProduct.isSky) {
                        navigate('/comparador/sky', { replace: false });
                    } else {
                        navigate('/comparador', { replace: false });
                    }
                }
            } else {
                fetchOfferWithAddress();
            }
        });

    fetchOfferWithAddress();
</script>

<div class="pure-g justify-content-center">
    <div class="pure-g">
        <div class="pure-u-1">
            <div class="text-center">
                <Preloader status="Validando solicitud" />
            </div>
        </div>
    </div>
</div>
